// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__25iaT","content":"GlobalSearch_content__xcHKc"};